var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2365 2.60133L6.41489 4.78299C5.07322 5.28466 3.97656 6.87133 3.97656 8.30633V16.9747C3.97656 18.3513 4.88658 20.1597 5.99491 20.988L11.0116 24.733C12.6566 25.9697 15.3632 25.9697 17.0082 24.733L22.0249 20.988C23.1332 20.1597 24.0432 18.3513 24.0432 16.9747V8.30633C24.0432 6.87133 22.9465 5.28466 21.6049 4.78299L15.7832 2.60133C14.7916 2.23966 13.2049 2.23966 12.2365 2.60133Z",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9948 18.0833C16.5721 18.0833 18.6615 15.994 18.6615 13.4167C18.6615 10.8393 16.5721 8.75 13.9948 8.75C11.4175 8.75 9.32812 10.8393 9.32812 13.4167C9.32812 15.994 11.4175 18.0833 13.9948 18.0833Z",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2865 11.958V13.043C14.2865 13.4513 14.0765 13.8363 13.7148 14.0463L12.8281 14.583",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityTimeIcon);
export default __webpack_public_path__ + "static/media/security-time-icon.44b820130457611c9c78c6a86967ae6a.svg";
export { ForwardRef as ReactComponent };